export default [
	{
		modulo: 25,
		privilegio: 188,
		routerName: 'controle-patrimonial',
		routerPath: '/controle-patrimonial',
		componentName: 'ControlePatrimonial',
		componentPath: 'modules/layout/estoque/controle-patrimonial/main'
	},
	{
		modulo: 25,
		privilegio: 189,
		routerName: 'suprimento-operacional',
		routerPath: '/suprimento-operacional',
		componentName: 'SuprimentoOperacional',
		componentPath: 'modules/layout/estoque/suprimento-operacional/main'
	},
	{
		modulo: 25,
		privilegio: 194,
		routerName: 'suprimento-tasa',
		routerPath: '/suprimento-tasa',
		componentName: 'SuprimentoTasa',
		componentPath: 'modules/layout/estoque/suprimento-tasa/main'
	},
	{
		modulo: 25,
		privilegio: 196,
		routerName: 'solicitacao-avulso',
		routerPath: '/solicitacao-avulso',
		componentName: 'SolicitacaoAvulsa',
		componentPath: 'modules/layout/manutencao/suprimento-aeronautico/main'
	}
]
